import { render, staticRenderFns } from "./Musicians.vue?vue&type=template&id=7b9a98d0&scoped=true&"
import script from "./Musicians.vue?vue&type=script&lang=js&"
export * from "./Musicians.vue?vue&type=script&lang=js&"
import style0 from "./Musicians.vue?vue&type=style&index=0&id=7b9a98d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a98d0",
  null
  
)

export default component.exports